<template>
  <sweet-modal
    overlay-theme="dark"
    hide-close-button
    ref="modal"
    enable-mobile-fullscreen
    class="no-padding-content"
    :width="$mq == 'mobile' ? '100%' : '50%'"
    @close="modalClosed"
  >
    <div class="bg-modal-gradient flex justify-between items-center p-6">
      <div class="text-white text-3xl">
        <i class="fa fa-comment mr-4"></i> Start a discussion
      </div>
      <div>
        <button
          type="button"
          class="text-white text-2xl hover:text-grey"
          @click="$refs.modal.close()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="p-6" v-show="vaultUsers.length > 0">
      <form
        @submit.prevent="postMessage"
        data-vv-scope="new-discussion"
        ref="drop_target"
        enctype="multipart/form-data"
      >
        <div class="w-full text-left my-4">
          <div class="flex justify-between">
            <label class="font-medium"
              >Title <span class="text-red">*</span></label
            >
            <label class="text-red text-sm font-medium">* Required info</label>
          </div>
          <input
            type="text"
            class="w-full h-10 border rounded px-3 mt-1"
            v-model="new_discussion.title"
            v-validate="'required'"
            name="msg_title"
            tabindex="1"
            :class="{ 'border-red': errors.has('new-discussion.msg_title') }"
          />
          <div
            v-show="errors.has('new-discussion.msg_title')"
            class="text-red text-sm mt-1"
          >
            {{ errors.first("new-discussion.msg_title") }}
          </div>
        </div>
        <div class="w-full text-left my-4">
          <label class="font-medium"
            >Message <span class="text-red">*</span></label
          >
          <textarea
            class="w-full border rounded py-2 px-3 mt-1"
            v-model="new_discussion.body"
            v-validate="'required'"
            name="msg_body"
            tabindex="1"
            :class="{ 'border-red': errors.has('new-discussion.msg_body') }"
          ></textarea>
          <div
            v-show="errors.has('new-discussion.msg_body')"
            class="text-red text-sm mt-1"
          >
            {{ errors.first("new-discussion.msg_body") }}
          </div>
        </div>
        <div class="w-full text-left my-4">
          <label class="font-medium"
            >Recipient <span class="text-red">*</span></label
          >
          <div class="flex flex-col md:flex-row mt-2 text-sm">
            <label class="flex content-center mr-4">
              <input
                class="mr-2 self-center h-4 w-4 hover:cursor-pointer"
                name="type"
                type="radio"
                checked
                @click="show_users = false"
                v-model="new_discussion.send_to"
                value="all_users"
              />
              All Vault members
            </label>
            <label class="flex content-center">
              <input
                class="mr-2 self-center h-4 w-4 hover:cursor-pointer"
                name="type"
                type="radio"
                @click="show_users = true"
                v-model="new_discussion.send_to"
                value="pick_users"
              />
              Let me choose who receives it
            </label>
          </div>

          <div class="my-2" v-if="show_users">
            <multiselect
              v-model="new_discussion.selected_users"
              class="rounded border"
              :class="{
                'border-red': errors.has('new-discussion.selected_users'),
              }"
              track-by="id"
              :custom-label="customLabel"
              placeholder="Search a User"
              :options="vaultUsers"
              :showLabels="false"
              :hide-selected="true"
              name="selected_users"
              v-validate="'required'"
              open-direction="above"
              :multiple="true"
            >
              <template slot="tag" slot-scope="props">
                <span
                  class="bg-brand-lighter text-grey-dark rounded-lg py-1 mr-2"
                >
                  <span class="font-semibold px-2 text-xs"
                    >{{ props.option.first_name }}
                    {{ props.option.last_name }}</span
                  >
                  <span
                    class="
                      text-brand
                      border-l border-brand-dark
                      px-2
                      hover:cursor-pointer
                    "
                    @click="props.remove(props.option)"
                  >
                    <i class="fa fa-times hover:text-brand-darker"></i>
                  </span>
                </span>
              </template>
            </multiselect>
            <div
              v-show="errors.has('new-discussion.selected_users')"
              class="text-red text-sm mt-1"
            >
              Message recipient is required
            </div>
          </div>
        </div>

        <file-upload
          ref="fileUpload"
          v-show="!vault.storage_exceeded"
        ></file-upload>

        <div
          v-if="vault.storage_exceeded"
          class="
            mt-4
            bg-red-lightest
            border border-dashed
            w-full
            p-1
            border-red
            text-sm
          "
        >
          Vault Storage Exceeded, uploading is not allowed
        </div>

        <div class="mt-6 flex justify-between items-center">
          <button
            class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
            type="submit"
          >
            <i class="fa fa-paper-plane mr-2"></i> Post message
          </button>
        </div>
      </form>
    </div>

    <div class="p-6 text-center" v-show="vaultUsers.length == 0">
      <p class="my-4">No Vault members found, please add a new member</p>
      <router-link
        :to="{
          name: 'invite-members',
          params: { vault_id: $route.params.vault_id },
        }"
        class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark no-underline"
        >Invite New Members</router-link
      >
    </div>
  </sweet-modal>
</template>

<script>
import FileUpload from "../FileUpload.vue";

export default {
  name: "AddDiscussion",
  props: ["vault", "vaultUsers"],
  components: {
    FileUpload,
  },
  data() {
    return {
      new_discussion: {
        send_to: "all_users",
      },
      selected_users: [],
      show_users: false,
    };
  },
  methods: {
    modalClosed() {
      this.resetState();
      this.$refs.fileUpload.cleanup();
    },
    resetState() {
      this.show_users = false;
      this.selected_users = [];
      this.new_discussion = {
        title: "",
        body: "",
        user_id: "",
        send_to: "all_users",
      };
      this.errors.clear("new-discussion");
    },
    customLabel(user) {
      if (!user.last_name) {
        return user.first_name;
      }
      return user.first_name + " " + user.last_name;
    },
    postMessage() {
      this.$validator.validateAll("new-discussion").then((result) => {
        if (result) {
          this.$emit("sending", true);

          let users = "";
          if (this.new_discussion.send_to == "all_users") {
            users = this.vaultUsers;
          }

          if (this.new_discussion.send_to == "pick_users") {
            users = this.new_discussion.selected_users;
          }

          this.createDiscussion(users);
        }
      });
    },
    createDiscussion(users) {
      const formData = new FormData();
      formData.append("title", this.new_discussion.title);
      users.forEach((user, index) => {
        formData.append(`participant_user_ids[${index}]`, user.id);
      });

      const files = this.$refs.fileUpload.getFiles();
      const vaultFiles = this.$refs.fileUpload.getVaultFiles();
      files.forEach((file, index) => {
        formData.append(`files[${index}]`, file);
      });
      vaultFiles.forEach((file, index) => {
        formData.append(`vault_files[${index}]`, file.id);
      });

      // create discussion
      axios
        .post(
          `api/vaults/${this.$route.params.vault_id}/discussions`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if(response && response.data) {
            const data = response.data;

            // send message
            axios
              .post(
                `api/vaults/${this.$route.params.vault_id}/discussions/${data.id}/messages`,
                {
                  message: this.new_discussion.body,
                }
              )
              .then((response) => {
                if (response && response.data) {
                  const data = response.data;
                  if (data.success) {
                    this.$noty.success(data.message);
                  }
                }

                this.$emit("getDiscussions");

                this.$ebus.$emit("refresh-file-and-tag-panel");
                this.$ebus.$emit("update-discussion-count");

                this.$emit("sending", false);
                this.resetState();
                this.$refs.modal.close();
              });
          } else {
            if(response && response.data) {
              let data = response.data;
              if (!data.success) {
              this.$emit("sending", false);
                this.$noty.error(data.message);
              }
            }
          }
        })
        .catch((error) => {
          let data = error.response.data;
          if (!data.success) {
            this.$emit("sending", false);
            this.$noty.error(data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
button:focus {
  outline: none;
}

.multiselect >>> .multiselect__tags {
  padding-bottom: 10px !important;
  border: none !important;
}
</style>